import { Component, EventEmitter, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "@angular/common";
import * as i3 from "ngx-skeleton-loader";
import * as i4 from "primeng/inputtext";
import * as i5 from "../icon-v2/icon.component";
import * as i6 from "../field-error/field-error.component";
import * as i7 from "@ngx-translate/core";
const _c0 = (a0, a1) => ({
  "gea-always-float-label": a0,
  "has-suffix-icon": a1
});
const _c1 = a0 => ({
  "gea-floating ": a0
});
const _c2 = () => ({
  height: "40px",
  width: "100%"
});
function InputV2Component_div_0_label_3_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " *");
    i0.ɵɵelementEnd();
  }
}
function InputV2Component_div_0_label_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, InputV2Component_div_0_label_3_span_3_Template, 2, 0, "span", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r1.initialValue))("for", ctx_r1.labelId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r1.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.required);
  }
}
function InputV2Component_div_0_geaui_icon_v2_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 12);
    i0.ɵɵlistener("click", function InputV2Component_div_0_geaui_icon_v2_4_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.suffixIconClicked.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("file", ctx_r1._suffixIcon);
    i0.ɵɵproperty("clickable", ctx_r1.suffixIconClickable)("color", ctx_r1.isDisabled ? "light-grey" : "black")("fileSize", 16);
  }
}
function InputV2Component_div_0_geaui_icon_v2_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 13);
    i0.ɵɵlistener("click", function InputV2Component_div_0_geaui_icon_v2_5_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onClear());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("clickable", true)("color", ctx_r1.isDisabled ? "light-grey" : "grey");
  }
}
function InputV2Component_div_0_geaui_field_error_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-field-error", 14);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("fieldName", i0.ɵɵpipeBind1(1, 4, ctx_r1.label))("fieldValue", ctx_r1.control == null ? null : ctx_r1.control.value)("submitted", ctx_r1.submitted)("errors", ctx_r1.control == null ? null : ctx_r1.control.errors);
  }
}
function InputV2Component_div_0_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, ctx_r1.helpText));
  }
}
function InputV2Component_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 3)(2, "input", 4);
    i0.ɵɵlistener("keydown", function InputV2Component_div_0_Template_input_keydown_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pressed = true);
    })("keyup.enter", function InputV2Component_div_0_Template_input_keyup_enter_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.keyUpEnter.emit());
    })("focusout", function InputV2Component_div_0_Template_input_focusout_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      ctx_r1.pressed = false;
      return i0.ɵɵresetView(ctx_r1.focusOut.emit());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, InputV2Component_div_0_label_3_Template, 4, 8, "label", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, InputV2Component_div_0_geaui_icon_v2_4_Template, 1, 4, "geaui-icon-v2", 6)(5, InputV2Component_div_0_geaui_icon_v2_5_Template, 1, 2, "geaui-icon-v2", 7)(6, InputV2Component_div_0_geaui_field_error_6_Template, 2, 6, "geaui-field-error", 8)(7, InputV2Component_div_0_span_7_Template, 4, 3, "span", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.isDisabled ? ctx_r1.floatLabelWhileDisabled ? "p-float-label custom-disable" : "custom-disable" : (ctx_r1.label == null ? null : ctx_r1.label.trim()) ? "p-float-label" : "");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("gea-pressed", ctx_r1.pressed);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c0, ctx_r1.alwaysFloatLabel, ctx_r1._suffixIcon && !ctx_r1.canClear))("id", ctx_r1.labelId)("type", ctx_r1.inputTypeMap[ctx_r1.type])("readonly", ctx_r1.isDisabled)("formControlName", (tmp_9_0 = ctx_r1.formName) !== null && tmp_9_0 !== undefined ? tmp_9_0 : ctx_r1.id)("disabled", ctx_r1.isDisabled)("placeholder", ctx_r1.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showLabel());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._suffixIcon && !ctx_r1.canClear);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.canClear && ctx_r1.initialValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.helpText && !(ctx_r1.control == null ? null : ctx_r1.control.errors));
  }
}
function InputV2Component_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c2));
  }
}
export class InputV2Component {
  formBuilder;
  destroyed;
  type = 'text';
  label = '';
  id = 'input';
  formName = undefined;
  loading = false;
  group;
  suffixIconClickable = false;
  set suffixIcon(suffixIcon) {
    this._suffixIcon = suffixIcon;
  }
  placeholder = '';
  canClear = false;
  initialValue = '';
  helpText;
  disabled = false;
  required = false;
  submitted = false;
  floatLabelWhileDisabled = true;
  alwaysFloatLabel = false;
  valueChanged = new EventEmitter();
  focusOut = new EventEmitter();
  keyUpEnter = new EventEmitter();
  suffixIconClicked = new EventEmitter();
  clearEvent = new EventEmitter();
  _suffixIcon = '';
  pressed = false;
  inputTypeMap = {
    text: 'text',
    phone: 'tel',
    mail: 'email',
    url: 'url',
    number: 'number'
  };
  constructor(formBuilder, destroyed) {
    this.formBuilder = formBuilder;
    this.destroyed = destroyed;
    this.group = this.group || this.formBuilder.group({
      [this.formName ?? this.id]: new FormControl('')
    });
  }
  get control() {
    return this.group.get(this.formName ?? this.id);
  }
  get isDisabled() {
    return this.control?.disabled;
  }
  //CE-6162 The input id needs an suffix -labelId to fix some console errors
  //with Incorrect use of <label for=FORM_ELEMENT>
  get labelId() {
    return this.id + '-labelId';
  }
  ngOnInit() {
    if ((this.formName ?? this.id) === '') {
      throw new Error('please provide an id for the form field');
    }
    if (this.initialValue) {
      this.control?.setValue(this.initialValue);
    }
    this.control?.valueChanges.pipe(takeUntilDestroyed(this.destroyed)).subscribe(value => this.valueChanged.emit(value));
  }
  onClear() {
    this.control?.patchValue('');
    this.clearEvent.emit();
  }
  ngOnChanges(changes) {
    if (changes['disabled']) {
      const isDisabled = changes['disabled'].currentValue;
      isDisabled ? this.control?.disable() : this.control?.enable();
    }
  }
  showLabel() {
    const isInitialValue = !!(this.initialValue ?? this.control?.value);
    return !!this.label && !(this.disabled && isInitialValue && !this.floatLabelWhileDisabled);
  }
  static ɵfac = function InputV2Component_Factory(t) {
    return new (t || InputV2Component)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i0.DestroyRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: InputV2Component,
    selectors: [["geaui-input-v2"]],
    inputs: {
      type: "type",
      label: "label",
      id: "id",
      formName: "formName",
      loading: "loading",
      group: "group",
      suffixIconClickable: "suffixIconClickable",
      suffixIcon: "suffixIcon",
      placeholder: "placeholder",
      canClear: "canClear",
      initialValue: "initialValue",
      helpText: "helpText",
      disabled: "disabled",
      required: "required",
      submitted: "submitted",
      floatLabelWhileDisabled: "floatLabelWhileDisabled",
      alwaysFloatLabel: "alwaysFloatLabel"
    },
    outputs: {
      valueChanged: "valueChanged",
      focusOut: "focusOut",
      keyUpEnter: "keyUpEnter",
      suffixIconClicked: "suffixIconClicked",
      clearEvent: "clearEvent"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 2,
    consts: [["skeleton", ""], ["class", "gea-input-container gea-form-container-margin", 3, "formGroup", 4, "ngIf", "ngIfElse"], [1, "gea-input-container", "gea-form-container-margin", 3, "formGroup"], [3, "ngClass"], ["pInputText", "", "data-cy", "input", "autocomplete", "on", 1, "gea-input-field", 3, "keydown", "keyup.enter", "focusout", "ngClass", "id", "type", "readonly", "formControlName", "disabled", "placeholder"], ["data-cy", "label", 3, "ngClass", "for", 4, "ngIf"], ["class", "gea-suffix-icon-16", 3, "clickable", "color", "fileSize", "file", "click", 4, "ngIf"], ["class", "gea-suffix-icon-16", "file", "16px_close", 3, "clickable", "color", "click", 4, "ngIf"], [3, "fieldName", "fieldValue", "submitted", "errors", 4, "ngIf"], ["class", "gea-helpText-container-input", 4, "ngIf"], ["data-cy", "label", 3, "ngClass", "for"], [4, "ngIf"], [1, "gea-suffix-icon-16", 3, "click", "clickable", "color", "fileSize", "file"], ["file", "16px_close", 1, "gea-suffix-icon-16", 3, "click", "clickable", "color"], [3, "fieldName", "fieldValue", "submitted", "errors"], [1, "gea-helpText-container-input"], [1, "gea-input-container", "gea-form-container-margin"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function InputV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, InputV2Component_div_0_Template, 8, 19, "div", 1)(1, InputV2Component_ng_template_1_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const skeleton_r5 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", skeleton_r5);
      }
    },
    dependencies: [i2.NgClass, i2.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName, i3.NgxSkeletonLoaderComponent, i4.InputText, i5.IconComponent, i6.FieldErrorComponent, i7.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-input-v2',
      template: "<div class=\"gea-input-container gea-form-container-margin\" *ngIf=\"!loading; else skeleton\" [formGroup]=\"group\">\n  <span\n    [ngClass]=\"\n      isDisabled\n        ? floatLabelWhileDisabled\n          ? 'p-float-label custom-disable'\n          : 'custom-disable'\n        : label?.trim()\n          ? 'p-float-label'\n          : ''\n    \">\n    <input\n      class=\"gea-input-field\"\n      [class.gea-pressed]=\"pressed\"\n      [ngClass]=\"{ 'gea-always-float-label': alwaysFloatLabel, 'has-suffix-icon': _suffixIcon && !canClear }\"\n      [id]=\"labelId\"\n      [type]=\"inputTypeMap[type]\"\n      [readonly]=\"isDisabled\"\n      [formControlName]=\"formName ?? id\"\n      [disabled]=\"isDisabled\"\n      [placeholder]=\"placeholder\"\n      (keydown)=\"pressed = true\"\n      (keyup.enter)=\"keyUpEnter.emit()\"\n      (focusout)=\"pressed = false; focusOut.emit()\"\n      pInputText\n      data-cy=\"input\"\n      autocomplete=\"on\" />\n    <label *ngIf=\"showLabel()\" [ngClass]=\"{ 'gea-floating ': initialValue }\" [for]=\"labelId\" data-cy=\"label\">\n      {{ label | translate }}\n      <span *ngIf=\"required\"> *</span>\n    </label>\n  </span>\n  <geaui-icon-v2\n    class=\"gea-suffix-icon-16\"\n    *ngIf=\"_suffixIcon && !canClear\"\n    [clickable]=\"suffixIconClickable\"\n    [color]=\"isDisabled ? 'light-grey' : 'black'\"\n    [fileSize]=\"16\"\n    (click)=\"suffixIconClicked.emit()\"\n    file=\"{{ _suffixIcon }}\">\n  </geaui-icon-v2>\n  <geaui-icon-v2\n    class=\"gea-suffix-icon-16\"\n    *ngIf=\"canClear && initialValue\"\n    [clickable]=\"true\"\n    [color]=\"isDisabled ? 'light-grey' : 'grey'\"\n    (click)=\"onClear()\"\n    file=\"16px_close\">\n  </geaui-icon-v2>\n  <geaui-field-error\n    *ngIf=\"label\"\n    [fieldName]=\"label | translate\"\n    [fieldValue]=\"control?.value\"\n    [submitted]=\"submitted\"\n    [errors]=\"control?.errors\"></geaui-field-error>\n  <span class=\"gea-helpText-container-input\" *ngIf=\"helpText && !control?.errors\">\n    <p>{{ helpText | translate }}</p>\n  </span>\n</div>\n<ng-template #skeleton>\n  <div class=\"gea-input-container gea-form-container-margin\">\n    <ngx-skeleton-loader [theme]=\"{ height: '40px', width: '100%' }\" count=\"1\" appearance=\"line\"></ngx-skeleton-loader>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i0.DestroyRef
  }], {
    type: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    formName: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    group: [{
      type: Input
    }],
    suffixIconClickable: [{
      type: Input
    }],
    suffixIcon: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    canClear: [{
      type: Input
    }],
    initialValue: [{
      type: Input
    }],
    helpText: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    submitted: [{
      type: Input
    }],
    floatLabelWhileDisabled: [{
      type: Input
    }],
    alwaysFloatLabel: [{
      type: Input
    }],
    valueChanged: [{
      type: Output
    }],
    focusOut: [{
      type: Output
    }],
    keyUpEnter: [{
      type: Output
    }],
    suffixIconClicked: [{
      type: Output
    }],
    clearEvent: [{
      type: Output
    }]
  });
})();
